<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Table of Contents</p>
<p class="P_TOC_Entry_1"><a href="#/section0002#auto_bookmark_toc_1">Blurb</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#auto_bookmark_toc_1">Text</a></p>
<p class="P_TOC_Entry_1"><span href="#/section0004#auto_bookmark_toc_1" title="Link target outside of Sample">About the Author</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0005#auto_bookmark_toc_1" title="Link target outside of Sample">By Kim Fielding</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0006" title="Link target outside of Sample">Visit Dreamspinner Press</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0007#auto_bookmark_toc_2" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?debe5352